import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

export function FacebookPhotoNotice({ postUrl, dark = false }: { postUrl?: string; dark?: boolean }) {
    if (!postUrl) return null;

    return (
        <div className={`flex flex-col gap-2 rounded-xl border p-4 text-sm sm:flex-row sm:items-center sm:justify-between ${dark ? 'border-white/20 bg-black/80 text-white' : 'border-gray-200 bg-gray-50 text-gray-700'}`}>
            <p>The original post may have more photos.</p>
            <a
                href={postUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={`inline-flex min-h-10 items-center gap-2 self-start rounded-md px-3 py-2 font-semibold underline underline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:shrink-0 ${dark ? 'text-white hover:bg-white/10' : 'text-blue-700 hover:bg-blue-50'}`}
                data-umami-event="More photos on Facebook clicked"
            >
                More photos on Facebook
                <ArrowTopRightOnSquareIcon className="h-4 w-4" aria-hidden="true" />
            </a>
        </div>
    );
}
